// extracted by mini-css-extract-plugin
export default {"localForm":"Company_localForm__HOb1W","ant-input":"Company_ant-input__HfaiL","inputReg":"Company_inputReg__bF+A6"};